import { projectContext } from '@/layouts/MainLayout'
import { OrganizationContext } from '@/pages/Organizations/Item'
import { useContext } from 'react'

export default function useProjectContext() {
  const { projectId } = useContext(projectContext)
  const orgData = useContext(OrganizationContext).orgData

  if (projectId) {
    return {projectId }
  } else {
    return {
      projectType: 'organizations',
      projectId: orgData?.id
    }
  }
}
